export const sendMetrik = (type, value) => {
    window.ym(81866044, type, value);
}